var _mask, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContentSectionImgDeco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 520,
    height: 311,
    viewBox: "0 0 520 311",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_146_1376",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-0.000732422 20.002C-0.000732422 8.95626 8.95357 0.00195312 19.9993 0.00195312L499.999 0.00195312C511.045 0.00195312 519.999 8.95626 519.999 20.002V283.479C518.261 283.166 516.47 283.002 514.641 283.002C499.085 283.002 486.294 294.842 484.789 310.002L41.8131 310.002C40.3079 294.842 27.5172 283.002 11.9612 283.002C7.70929 283.002 3.66399 283.886 -0.000732422 285.482L-0.000732422 20.002Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M519.999 283.479L519.644 285.447L521.999 285.872V283.479H519.999ZM484.789 310.002V312.002H486.6L486.779 310.2L484.789 310.002ZM41.8131 310.002L39.8228 310.2L40.0018 312.002H41.8131V310.002ZM-0.000732422 285.482H-2.00073L-2.00073 288.533L0.797463 287.315L-0.000732422 285.482ZM19.9993 -1.99805C7.849 -1.99805 -2.00073 7.85169 -2.00073 20.002H1.99927C1.99927 10.0608 10.0581 2.00195 19.9993 2.00195V-1.99805ZM499.999 -1.99805L19.9993 -1.99805V2.00195L499.999 2.00195V-1.99805ZM521.999 20.002C521.999 7.85169 512.15 -1.99805 499.999 -1.99805V2.00195C509.94 2.00195 517.999 10.0608 517.999 20.002H521.999ZM521.999 283.479V20.002H517.999V283.479H521.999ZM514.641 285.002C516.35 285.002 518.022 285.155 519.644 285.447L520.354 281.511C518.499 281.176 516.589 281.002 514.641 281.002V285.002ZM486.779 310.2C488.184 296.052 500.123 285.002 514.641 285.002V281.002C498.047 281.002 484.405 293.632 482.799 309.804L486.779 310.2ZM41.8131 312.002L484.789 312.002V308.002L41.8131 308.002V312.002ZM11.9612 285.002C26.479 285.002 38.4182 296.052 39.8228 310.2L43.8033 309.804C42.1975 293.632 28.5555 281.002 11.9612 281.002L11.9612 285.002ZM0.797463 287.315C4.21508 285.828 7.98905 285.002 11.9612 285.002L11.9612 281.002C7.42952 281.002 3.1129 281.945 -0.798928 283.648L0.797463 287.315ZM-2.00073 20.002L-2.00073 285.482H1.99927L1.99927 20.002H-2.00073Z",
    fill: "url(#paint0_linear_146_1376)",
    mask: "url(#path-1-inside-1_146_1376)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_146_1376",
    x1: 239.999,
    y1: -7.48081,
    x2: 239.999,
    y2: 310.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5948C8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5948C8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentSectionImgDeco);
export default __webpack_public_path__ + "static/media/content-section-img-deco.d64e5300e254f9955aa025ded352e5d8.svg";
export { ForwardRef as ReactComponent };